module.exports = __webpack_public_path__ + "static/img/leaveInformationmui.56ed6f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/leaveInformationmui.png
// module id = 8Ytk
// module chunks = 1